<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.editAssumption')"
        :rules="rulesAssumptionCosting"
        :submit="submit"
        @close="close">
        <div
            v-if="visible"
            class="grid gap-4 grid-cols-1">
            <hts-select-category-vehicle
                v-model="formEditData.categoryVehicle"
                v-model:name="formEditData.categoryVehicleName"
                :label="$t('labels.vehicleType')"
                required
                prop="vehicleCategory" />
            <hts-form-input
                v-model="formEditData.indicator"
                :label="$t('labels.indicator')"
                type="number"
                required
                prop="indicator"
                name="indicator" />
            <hts-form-select
                v-model="formEditData.name"
                :label="$t('labels.nameAssumption')"
                :items="listNameAssumption"
                required
                key-id="key"
                key-label="title"
                prop="nameAssumption"
                name="nameAssumption" />
        </div>
        <template #footer>
            <div class="flex flex-row gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="creating">
                    {{ $t('labels.save') }}
                </hts-form-button>

                <hts-form-button
                    icon-name="hi-x-mark-icon"
                    icon-position="right"
                    color="error"
                    @click="visible = false">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-drawer>
</template>

<script setup lang="ts">
import { IUpdateCostingAssumption } from '~/pages/trucker-[id]/cost/ignore/imports/form'

const rulesAssumptionCosting = {
  nameAssumption: 'required',
  indicator: 'required|numeric'
}
const visible = ref(false)
const creating = ref(false)
const resetForm = () => {
  Object.assign(formEditData, {
    name: '',
    categoryVehicle: '',
    categoryVehicleName: '',
    indicator: ''
  })
}
const formEditData = reactive<IUpdateCostingAssumption>({
  name: '',
  categoryVehicle: '',
  categoryVehicleName: '',
  indicator: ''
})
const close = () => {
  resetForm()
  visible.value = false
}

const emits = defineEmits(['refreshTables'])
const assumptionCostingId = ref('')
const open = (id: string) => {
  assumptionCostingId.value = id
  visible.value = true
  _initData()
}
defineExpose({
  open
})

const submit = () => {
  const api = $url.cost.assumption.updateAssumption
  creating.value = true
  $api(api, { body: formEditData, uriParams: { ID: assumptionCostingId.value } })
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        resetForm()
        process.client && $toast().success($t('labels.editAssumptionSuccess'))
      }
      emits('refreshTables')
      creating.value = false
      visible.value = false
    })
    .catch(() => {
      creating.value = false
      visible.value = false
      resetForm()
    })
}
const loading = ref(false)
const _initData = () => {
  const api = $url.cost.assumption.assumptionDetail
  loading.value = true
  $api(api, { uriParams: { ID: assumptionCostingId.value } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        Object.assign(formEditData, resData.data)
        loading.value = false
      }
    })
    .catch(() => {
      loading.value = false
    })
}

const listNameAssumption = [
  {
    key: 'ASSUMPTION_GASOLINE',
    title: $t('labels.assumptionGasoline')
  }
]
</script>
